import { render, staticRenderFns } from "./staffworkhrspopover_component.vue?vue&type=template&id=275386d4&scoped=true&"
import script from "../assets/js/StaffWorkHrsComponent.js?vue&type=script&lang=js&"
export * from "../assets/js/StaffWorkHrsComponent.js?vue&type=script&lang=js&"
import style0 from "./staffworkhrspopover_component.vue?vue&type=style&index=0&id=275386d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275386d4",
  null
  
)

export default component.exports